import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["picker"]
  static values = {
    reactableId: String,
    reactableType: String
  }

  toggle(event) {
    const emoji = event.params.emoji
    this.submitReaction(emoji)
  }

  showPicker() {
    this.pickerTarget.classList.toggle("hidden")
  }

  react(event) {
    const emoji = event.params.emoji
    this.pickerTarget.classList.add("hidden")
    this.submitReaction(emoji)
  }

  submitReaction(emoji) {
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch("/reactions", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": token
      },
      body: JSON.stringify({
        reaction: {
          reactable_type: this.reactableTypeValue,
          reactable_id: this.reactableIdValue,
          emoji: emoji
        }
      })
    })
    .then(response => response.text())
    .then(html => {
      Turbo.renderStreamMessage(html)
    })
  }

  // Close picker when clicking outside
  connect() {
    this.outsideClickHandler = (event) => {
      if (this.hasPickerTarget && !this.element.contains(event.target)) {
        this.pickerTarget.classList.add("hidden")
      }
    }
    document.addEventListener("click", this.outsideClickHandler)
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClickHandler)
  }
}
